import { render, staticRenderFns } from "./agreementPopup.vue?vue&type=template&id=56d39231&scoped=true"
import script from "./agreementPopup.vue?vue&type=script&lang=js"
export * from "./agreementPopup.vue?vue&type=script&lang=js"
import style0 from "./agreementPopup.vue?vue&type=style&index=0&id=56d39231&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d39231",
  null
  
)

export default component.exports